function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(252, 249, 237)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'peak-green': 'rgb(5, 155, 96)','orange': 'rgb(233, 67, 16)','navy': 'rgb(25, 28, 56)','magenta': 'rgb(213, 24, 91)','dark-red': 'rgb(128, 20, 20)','yellow': 'rgb(250, 188, 43)','red': 'rgb(254, 20, 43)','blue': 'rgb(54, 223, 237)','bright-green': 'rgb(162, 242, 16)','pink': 'rgb(254, 76, 142)','purple': 'rgb(140, 64, 111)','turquoise': 'rgb(52, 235, 207)','navy-blue': 'rgb(25, 28, 56)',};

    this.images = {'pink-yellow': 'url("//www.psychi.co.uk/cdn/shop/files/Pink_Yellow_120x.png?v=5225976099027261171")','vanilla-balm': 'url("//www.psychi.co.uk/cdn/shop/files/vanilla_120x.png?v=8135770050336003038")','mint-balm': 'url("//www.psychi.co.uk/cdn/shop/files/mint_120x.png?v=13995310850913516629")','lavender-balm': 'url("//www.psychi.co.uk/cdn/shop/files/lavender_120x.png?v=11397481998978943354")','red-grey': 'url("//www.psychi.co.uk/cdn/shop/files/red-grey_120x.png?v=15517104253089981325")','green': 'url("//www.psychi.co.uk/cdn/shop/files/green-green_120x.png?v=13761717357972014332")','purple-teal': 'url("//www.psychi.co.uk/cdn/shop/files/purple-green_120x.png?v=6767199760531391588")','black-grey': 'url("//www.psychi.co.uk/cdn/shop/files/black-grey_120x.png?v=173804863672938565")','green-easy': 'url("//www.psychi.co.uk/cdn/shop/files/Green-Easy_120x.png?v=11884070549979443234")','grey-medium': 'url("//www.psychi.co.uk/cdn/shop/files/Grey-Medium_120x.png?v=10456795092929690065")','black-hard': 'url("//www.psychi.co.uk/cdn/shop/files/Black-Hard_120x.png?v=4074688271677222368")','grip-set': 'url("//www.psychi.co.uk/cdn/shop/files/grip-set_120x.png?v=5569406072968645231")','grey-navy': 'url("//www.psychi.co.uk/cdn/shop/files/pad-grey-navy_120x.png?v=9392138822910735968")','navy-orange': 'url("//www.psychi.co.uk/cdn/shop/files/pad-navy-orange_120x.png?v=10228979561323646097")','orange-turquoise': 'url("//www.psychi.co.uk/cdn/shop/files/pad-orange-turquoise_120x.png?v=16385569870476366645")','purple-lime': 'url("//www.psychi.co.uk/cdn/shop/files/pad-purple-lime_120x.png?v=10400757623654074362")','red-blue': 'url("//www.psychi.co.uk/cdn/shop/files/pad-red-blue_120x.png?v=18225494867268863901")','turquoise-orange': 'url("//www.psychi.co.uk/cdn/shop/files/pad-turquoise-orange_120x.png?v=3225289307575547635")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
